import React,{useEffect,useState,useContext} from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';
import ReactSelect from 'react-select';
import { Context } from '../../context/UserContext';

const Index = () => {

    const context = useContext(Context);
    const {readData} = useEntityCrud('Discount/GetAllDiscounts');
    const {addData: updateData} = useEntityCrud('Discount/ChangeStatus');
    const {addData: updateDiscountPersons} = useEntityCrud('Discount/updateDiscountPerson');
    const {readData: getBranchs} = useEntityCrud('Branch/GetAllBranchs');
    const {readData: getDiscountPersons} = useEntityCrud('Discount/getDiscountPersons');
    const {readData: getPersons} = useEntityCrud('Person/getAllPersons');
    const [rows,setRows] = useState([]);
    const [branchs,setBranchs] = useState([]);
    const [branchId,setBranchId] = useState(0);
    const [searched,setSearched] = useState(false);
    const [discountId,setDiscountId] = useState(0);
    const [persons,setPersons] = useState([]);
    const [selectedPersons,setSelectedPersons] = useState([]);

    const getData = () => {
        readData({branchId,title: '',branchTitle: '',discountCode: '',subServiceTitle: ''}).then(({data}) => {
            if(data.status)
                setRows(data.result);
        });
    }

    useEffect(() => {
        getBranchs().then(({data}) => {
            if(data.status)
                setBranchs(data.result);
        });
        const postedData = {
            name: '',
            lastName: '',
            email: '',
            phone: '',
            cellphone: '',
            branchTitle: '',
            nationalCode: ''
        };
        getPersons(postedData).then(({data}) => {
            let allPersons = [];
            if(data.status){
                data.result.map(person => {
                    allPersons.push({
                        label: person.name + ' ' + person.lastName,
                        value: person.id
                    });
                })
            }
            setPersons(allPersons);
        });
    },[])

    useEffect(() => {
        if(branchId != 0){
            setSearched(true);
            getData();
        }
    },[branchId])

    useEffect(() => {
        const postedData = {
            id: discountId,
            title: '',
            branchTitle: '',
            discountCode: '',
            subServiceTitle: ''
        };
        if(discountId != 0)
            getDiscountPersons(postedData).then(({data}) => {
                let allPersons = [];
                if(data.status){
                    data.result.map(person => {
                        allPersons.push({
                            label: person.name + ' ' + person.lastName,
                            value: person.id
                        });
                    })
                }
                setSelectedPersons(allPersons);
            })
    },[discountId])

    const submitModalUpdate = () => {
        let element = document.getElementById('change-persons');
        let modal = window.bootstrap.Modal.getInstance(element);
        let generateNewPersons = [];
        selectedPersons.map(person => {
            generateNewPersons.push(person.value);
        });
        const postedData = {
            discountId,
            personId: generateNewPersons
        };
        updateDiscountPersons(postedData).then(({data}) => {
            if(data.status){
                toast.success('لیست پرسنل مشمول تخفیف با موفقیت به روزرسانی شد');
                modal.hide();
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const deActiveRow = id => {
        const postedData = {
            id,
            status: false
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت کد تخفیف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = id => {
        const postedData = {
            id,
            status: true
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت کد تخفیف مورد نظر با موفقیت به روزرسانی شد');
                getData();
            }else
                data.errors.map(error => toast.error(error.message));
        });
    }

 
    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">کد های تخفیف</div>
            </div>
            <div className="card-body">
                {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ایجاد کد تخفیف</Link> : ''}
                <button className="btn btn-dark mx-2 accordion-toggle collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseFour" aria-expanded="false">جستجو</button>
                <div className="panel-group1" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse" role="tabpanel" aria-expanded="false">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mt-4 mb-2">
                                    <label>شرکت زیر مجموعه</label>
                                    <select className="form-control" onChange={e => setBranchId(e.target.value)}>
                                        <option value="">انتخاب کنید</option>
                                        {branchs.map(branch => (
                                            <option value={branch.id}>{branch.title}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {rows.length ? <hr /> : ''}
                {rows.length ? <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>درصد تخفیف</th>
                            <th>حداکثر تخفیف</th>
                            <th>شرکت زیر مجموعه</th>
                            <th>وضعیت</th>
                            <th>عملیات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((item,index) => (
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{item.discountPercentage}%</td>
                                <td>{item.maxDiscount} ریال</td>
                                <td>{item.branchTitle}</td>
                                <td>{item.isActive ? <i className="fe fe-check text-success"></i> : <i className="fe fe-x text-danger"></i>}</td>
                                <td className="btn-list">
                                    {context.checkHasPermission('update') ? <Link to={'update/' + item.id} className="btn btn-icon mb-0 btn-primary" title="ویرایش"><i className="fe fe-edit-2"></i></Link> : ''}
                                    {context.checkHasPermission('delete') ? (item.isActive ? <button onClick={e => deActiveRow(item.id)} className="btn btn-icon mb-0 btn-danger" title="غیرفعال سازی"><i className="fe fe-x"></i></button> : <button onClick={e => activeRow(item.id)} className="btn btn-icon mb-0 btn-success" title="فعال سازی"><i className="fe fe-check"></i></button>) : ''}
                                    {context.checkHasPermission('update') ? <a href="#change-persons" data-bs-effect="effect-slide-in-right" data-bs-toggle="modal" className="btn btn-icon mb-0 btn-dark" onClick={e => setDiscountId(item.id)}><i className="fe fe-users"></i></a> : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : (searched ? <div className="alert alert-info mt-4"><p>کد تخفیفی برای این شرکت زیر مجموعه یافت نشد</p></div> : <div className="alert alert-info mt-4"><p>جهت نمایش لیست کد های تخفیف یک شرکت زیر مجموعه را انتخاب کنید</p></div>)}
            </div>
            <div className="modal fade" id="change-persons" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered text-center" role="document">
                    <div className="modal-content modal-content-demo">
                        <div className="modal-header">
                            <h6 className="modal-title">ویرایش پرسنل ذی نفع</h6><button aria-label="Close" className="btn-close" data-bs-dismiss="modal"><span aria-hidden="true ">×</span></button>
                        </div>
                        <div className="modal-body">
                            <ReactSelect options={persons} isMulti={true} value={selectedPersons} onChange={e => setSelectedPersons(e)} />
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-success" onClick={submitModalUpdate}>ذخیره تغییرات</button> <button className="btn btn-light" data-bs-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;